// 表单数据
const ruleForm = {
  Id: '',
  CustomType: '', // 用户角色
  BehaviorType: '', // 用户行为
  TargetAddress: '', // 指定地址
  TimeLimit: '', // 完成时限
  Scores: '', // 获取分值
  SupperLimit: '', // 每日积分上限
};
// 表单用户类型列表
const useRoleForm = [
  {
    label: '医生',
    value: 2,
  },
  {
    label: '员工',
    value: 1,
  },
];
// 表单用户行为列表
// 用户行为列表
const userBehaviorListForm = [];
// 向外暴露，利于外部引用
export { ruleForm, useRoleForm, userBehaviorListForm };
